import Header from '../components/common/Header';
import FloatingButton from '../components/common/FloatingButton';
import Footer from '../components/common/Footer';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
    
import SectionHero from "../components/home/SectionHero";
import SectionSolution from "../components/home/SectionSolution";
import SectionPartners from '../components/home/SectionPartners';

function Main() {
    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            <Header />
            <SectionHero />
            <SectionSolution />
            <SectionPartners />
            <FloatingButton />
            <Footer />
        </div>
    );
}

export default Main;
